import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent} from "src/app/pages/base.component";
import {TaskSidebarItem} from "src/app/shared/ag-task/ag-task.component.ds";
import {SurveyTracker} from "src/app/data/interefaces/panel.interfaces";
import {ActivatedRoute} from "@angular/router";
import {FeatureComponentMode} from "@core/enums/core.enums";

@Component({
  selector: 'app-survey-tracker-task',
  templateUrl: './survey-tracker-task.component.html',
  styleUrls: ['./survey-tracker-task.component.scss']
})
export class SurveyTrackerTaskComponent extends BaseComponent implements AfterViewInit {
  featureComponentSidebarEl: TaskSidebarItem[] = [
    {
      title: "Edit Row",
      icon: "fa-pen-to-square",
      selected: false,
      urlSupport: true,
      disabled: true,
      mode: FeatureComponentMode.EDIT_ROW
    },
    {
      title: "Request Response Files in Bulk",
      icon: "fa-files",
      selected: false,
      urlSupport: false,
      disabled: false,
      mode: FeatureComponentMode.BULK_REQUEST_FILES
    },
    {
      title: "Bulk Mailout",
      icon: "fa-envelopes-bulk",
      selected: false,
      urlSupport: false,
      disabled: false,
      mode: FeatureComponentMode.BULK_MAILOUT
    },
    {
      title: "Bulk Edit",
      icon: "fa-pen",
      selected: false,
      urlSupport: false,
      disabled: false,
      mode: FeatureComponentMode.BULK_EDIT
    },
    {
      title: "Upload",
      icon: "fa-upload",
      selected: false,
      urlSupport: true,
      disabled: false,
      mode: FeatureComponentMode.UPLOAD
    }
  ];
  @Input() selectedFeatureMode: FeatureComponentMode | undefined;
  @Input() selectedRows!: SurveyTracker[];
  @Input() preSelectedFeatureMode!: FeatureComponentMode;
  @Output() goBackEvent: EventEmitter<any> = new EventEmitter<any>();
  isUrlMode: boolean = false;
  urlModeGoBackUrl: string = "/forms/survey-respondents/survey-tracker";
  protected readonly FeatureComponentMode = FeatureComponentMode;

  constructor(protected _activatedRoute: ActivatedRoute) {
    super();
    let paramMode = this._activatedRoute.snapshot.params['mode'];
    if (paramMode) {
      this.isUrlMode = true;
      this.selectedFeatureMode = paramMode;
    }
  }

  ngAfterViewInit(): void {
  }
}
